export enum Role {
    ADMIN = 'admin',
    SUPERADMIN = 'superadmin',
    CPO = 'cpo',
    SUBCPO = 'subcpo',
    CMS = 'CMS',
    OPERATOR='operator',
    mobUser= "MobUser",
    STATIONMANAGER='stationManager',
    StationManager='stationmanager'
}

export enum ActualRole {
    CPO = 'CPO',
    SUBCPO = 'SubCpo',
    ADMIN = 'Admin'
}
